module.exports = __webpack_public_path__ + "static/media/bg.404f4616.png";